// extracted by mini-css-extract-plugin
export default {"passwordInput":"PasswordChangeModal_passwordInput__KFU55","passwordLabel":"PasswordChangeModal_passwordLabel__L-UdC"};